<!--
  FormItem: Mets 活动表单字段原子组件。
  只负责字段视觉与输入事件,不内置业务校验或提交状态机。
-->
<template>
  <div
    class="form-item"
    :class="[
      { isPC: pageType === 'PC' },
      `width-${width}`,
      `h5-gutter-${h5Gutter}`,
      `content-gap-${contentGap}`,
      {
        'has-error': !!error,
        'has-suffix': !!suffixText,
      },
    ]"
  >
    <div class="field-box">
      <div v-if="label" class="label-row">
        <label class="label">{{ label }}</label>
        <span v-if="required" class="required-mark" aria-hidden="true">
          *
        </span>
      </div>
      <div class="input-row">
        <input
          :type="type"
          :value="value"
          :placeholder="placeholder"
          @input="onInput"
          @blur="$emit('blur')"
        />
        <button
          v-if="suffixText"
          type="button"
          class="suffix-button"
          :disabled="suffixDisabled"
          @click="$emit('suffix-click')"
        >
          {{ suffixText }}
        </button>
      </div>
    </div>
    <div
      class="error-message"
      :class="{ 'is-empty': !error }"
      aria-live="polite"
    >
      {{ error }}
    </div>
  </div>
</template>

<script lang="ts">
type Props = {
  label?: string;
  required?: boolean;
  value: string;
  placeholder?: string;
  error?: string;
  type?: 'text' | 'email' | 'tel' | 'number';
  pageType: 'PC' | 'H5';
  width?: 'full' | 'half';
  suffixText?: string;
  suffixDisabled?: boolean;
  h5Gutter?: 'modal' | 'form' | 'none';
  contentGap?: 'modal' | 'compact';
};
const __sfc_main = {};
__sfc_main.props = {
  label: {
    key: "label",
    required: false,
    type: String,
    default: ''
  },
  required: {
    key: "required",
    required: false,
    type: Boolean,
    default: false
  },
  value: {
    key: "value",
    required: true,
    type: String
  },
  placeholder: {
    key: "placeholder",
    required: false,
    type: String,
    default: ''
  },
  error: {
    key: "error",
    required: false,
    type: String,
    default: ''
  },
  type: {
    key: "type",
    required: false,
    type: String,
    default: 'text'
  },
  pageType: {
    key: "pageType",
    required: true,
    type: String
  },
  width: {
    key: "width",
    required: false,
    type: String,
    default: 'full'
  },
  suffixText: {
    key: "suffixText",
    required: false,
    type: String,
    default: ''
  },
  suffixDisabled: {
    key: "suffixDisabled",
    required: false,
    type: Boolean,
    default: false
  },
  h5Gutter: {
    key: "h5Gutter",
    required: false,
    type: String,
    default: 'modal'
  },
  contentGap: {
    key: "contentGap",
    required: false,
    type: String,
    default: 'modal'
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const emit = __ctx.emit;
  function onInput(ev: Event): void {
    const target = ev.target as HTMLInputElement;
    emit('update:value', target.value);
  }
  return {
    onInput
  };
};
export default __sfc_main;
</script>

<style scoped>
.form-item {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.field-box {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background: #ffffff;
  border: 2px solid #e3e4e5;
}

.has-error .field-box {
  border-color: #e53751;
}

.label-row,
.input-row {
  display: flex;
  align-items: center;
}

.label-row {
  align-self: stretch;
}

.label {
  color: #626262;
}

.required-mark {
  color: #e53751;
}

.input-row {
  align-self: stretch;
  justify-content: stretch;
}

.input-row input {
  min-width: 0;
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  color: #121212;
  font: inherit;
}

.input-row input::placeholder {
  color: #bbbdc0;
}

.suffix-button {
  flex: none;
  padding: 0;
  border: none;
  background: transparent;
  color: #2b78f5;
  font: inherit;
  cursor: pointer;
}

.suffix-button:disabled {
  color: #bbbdc0;
  cursor: not-allowed;
}

.error-message {
  box-sizing: border-box;
  overflow: hidden;
  color: #e53751;
}

.error-message.is-empty {
  color: transparent;
}

/* H5:视觉稿 100px = 1rem */
.form-item.h5-gutter-modal {
  padding-top: 0.2rem;
  padding-right: 0.4rem;
  padding-bottom: 0;
  padding-left: 0.4rem;
}

.form-item.h5-gutter-modal.first-form-item {
  padding-top: 0.32rem;
}

.form-item.h5-gutter-form {
  padding-right: 0.34rem;
  padding-left: 0.34rem;
}

.form-item.width-half {
  width: 50%;
}

.field-box {
  border-radius: 0.2rem;
  padding: 0.21rem 0.24rem;
}

.form-item.h5-gutter-modal .field-box {
  padding: 0.2rem 0.24rem;
}

.form-item.content-gap-modal .field-box {
  gap: 0.24rem;
}

.form-item.content-gap-compact .field-box {
  gap: 0.04rem;
}

.label,
.required-mark {
  font-size: 0.26rem;
  line-height: 1.4em;
}

.form-item.h5-gutter-modal .label,
.form-item.h5-gutter-modal .required-mark {
  font-size: 0.3rem;
  line-height: 1.2em;
}

.input-row {
  gap: 0.1538rem;
}

.input-row input,
.suffix-button {
  font-size: 0.3rem;
  line-height: 1.4em;
}

.form-item.h5-gutter-modal .input-row input,
.form-item.h5-gutter-modal .suffix-button {
  font-size: 0.28rem;
  line-height: 1.35em;
}

.error-message {
  padding: 0.05rem 0.23rem 0;
  height: 0.45rem;
  font-size: 0.26rem;
  line-height: 1.4em;
}

/* PC: 大写 PX 用于跳过 postcss-pxtorem，避免字段固定尺寸被转成 rem 后受根字号影响 */
.form-item.isPC.width-half {
  width: calc((100% - 20PX) / 2);
}

.form-item.isPC,
.form-item.isPC.h5-gutter-modal,
.form-item.isPC.h5-gutter-modal.first-form-item,
.form-item.isPC.h5-gutter-form {
  position: relative;
  padding: 0; /* 覆盖 H5 默认的 gutter */
}

.form-item.isPC .field-box {
  border-width: 2px;
  border-radius: 12px;
  padding: 12px 24px;
  gap: 10px;
}

.form-item.isPC .label,
.form-item.isPC .required-mark {
  font-size: 20px;
  line-height: 1.4em;
  font-weight: 400;
}

.form-item.isPC .label {
  color: #626262;
}

.form-item.isPC .required-mark {
  color: #e53751;
}

.form-item.isPC .input-row {
  gap: 10px;
}

.form-item.isPC .input-row input,
.form-item.isPC .suffix-button {
  font-size: 18px;
  line-height: 1.4em;
}

.form-item.isPC .error-message {
  position: absolute;
  top: 100%;
  left: 0;
  padding: 4px 16px 0;
  height: 24px;
  font-size: 14px;
  line-height: 1.4em;
}
</style>
